import React from 'react';
import _ from '@dh-fe/translate';
import Icon, { IconList } from 'components/Icon';
import { useTheme } from 'contexts/ThemeContext';
import classnames from 'classnames';
import useMediaQuery from 'hooks/useMediaQuery';
import { Breakpoints } from 'configs/breakpoints';
import Image from 'components/Image/Image';
import style from './LifeSection.module.scss';
import { getContent } from './LifeSectionContent';

const LifeSection = () => {
    const { title, bg: bgDesktop, bgMobile } = getContent();
    const { theme } = useTheme();
    const isMobile = useMediaQuery(Breakpoints.VERY_SMALL);
    const bg = isMobile ? bgMobile : bgDesktop;

    return (
        <section className={classnames(style[theme], style.life)}>
            <Image unCompressed={bg} webp={bg} className={style.bg} alt="background image" />
            <div className={style.container}>
                <h1>{title}</h1>
                <h2>{_`Register an account, pick your preferred topic, and start making money!`}</h2>
                <div className={style.content}>
                    <div className={style.item}>
                        <Icon icon={IconList.homeSolid} size="5.6rem" />
                        <div>{_`Work from Home`}</div>
                    </div>
                    <div className={style.item}>
                        <Icon icon={IconList.coinDollarSolid} size="5.6rem" />
                        <div>{_`Get Paid for your Passion`}</div>
                    </div>
                    <div className={style.item}>
                        <Icon icon={IconList.groupThreeSolid} size="5.6rem" />
                        <div>{_`Reach New Audience`}</div>
                    </div>
                    <div className={style.item}>
                        <Icon icon={IconList.calendarSolid} size="5.6rem" />
                        <div>{_`Set your own Schedule`}</div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default LifeSection;
